import SUB_ACTIONS from "./sub/actions";
import { logErrorToSentry } from "../../helpers/sentry";
import AnalyticsService from "@emcd-shared/analytics-service";
export default {
  /**
   * Fetch paid by coin over a period of time.
   * @param {object} api - service from ApiService in local app
   * @param {string} coin - coin from coinService
   * @param {string} from - unix by UTC
   * @param {string} to - unix by UTC
   * @example
   * const api = ApiService.endpointApi
   * const coin = "btc";
   * const from = 14215125125;
   * const to = 24215125125;
   *
   * await fetchCoinRangePaid({ api, coin, from, to });
   */
  async fetchCoinRangePaid({ commit }, { api, coin, from, to }) {
    const isNotValidArguments = !api || !coin || !from || !to;

    if (isNotValidArguments) {
      AnalyticsService.error(`Not valid argument | fetchCoinRangePaid`, {
        api,
        coin,
        from,
        to,
      });
      throw new Error("fetchPaidCoinFromPeriod: wrong arguments");
    }

    try {
      const response = await api.get(
        `/profile/paid/${coin}`,
        new URLSearchParams({
          from,
          to,
        })
      );
      const paid = response?.paid;
      commit("SET_PAID_COIN_FROM_PERIOD", { coin, paid });
    } catch (e) {
      logErrorToSentry("fetchCoinRangePaid", "response.error", e);
      throw new Error(e);
    }
  },

  /**
   * Fetch user balance by coin
   * @param {object} api - service from ApiService in local app
   * @param {string} coin - coin from coinService
   * @example
   * const api = ApiService.endpointApi
   * const coin = "btc";
   *
   * await fetchUserCoinBalance({ api, coin });
   */
  async fetchUserCoinBalance({ commit }, { api, coin }) {
    const isNotValidArguments = !api || !coin;

    if (isNotValidArguments) {
      AnalyticsService.error(`Not valid argument | fetchCoinRangePaid`, {
        api,
        coin,
      });
      throw new Error("fetchBalanceFromCoin: wrong arguments");
    }

    try {
      const amount = await api.get(`/profile/balance/${coin}`);
      commit("SET_COIN_BALANCE", { coin, amount });
    } catch (e) {
      logErrorToSentry("fetchUserCoinBalance", "response.error", e);
      throw new Error(e);
    }
  },

  /**
   * Fetch user settings
   * @param {object} api - service from ApiService in local app
   *
   * @example
   * const api = ApiService.endpointApi
   *
   * await fetchSettings(api);
   */
  async fetchSettings({ commit }, api) {
    if (!api) {
      AnalyticsService.error(`Not valid argument | fetchSettings`, {
        api,
      });
      throw new Error("fetchSettings: wrong arguments");
    }

    try {
      const settings = await api.get(`/profile/settings`);
      commit("SET_SETTINGS", settings);
    } catch (e) {
      logErrorToSentry("fetchSettings", "response.error", e);
      throw new Error(e);
    }
  },

  /**
   * Fetch user settings
   * @param {object} api - get addresses of projects p2p/wallets & others
   *
   * @example
   * const api = ApiService.endpointApi
   *
   * await fetchAddresses(api);
   */
  async fetchAddresses({ commit }, api) {
    if (!api) {
      AnalyticsService.error(`Not valid argument | fetchAddresses`, {
        api,
      });
      throw new Error("fetchAddresses: wrong arguments");
    }

    try {
      const response = await api.get(`/profile/addresses`);
      const addresses = response?.addresses;
      commit("SET_ADDRESSES", addresses);
    } catch (e) {
      logErrorToSentry("fetchAddresses", "response.error", e);
      throw new Error(e);
    }
  },

  /**
   * Fetch accounts uuid & names
   * @param {object} api - service from ApiService in local app
   *
   * @example
   * const api = ApiService.endpointApi
   *
   * await fetchAccounts({ api });
   */
  async loadAccountList({ commit }, api ) {
    const isNotValidArguments = !api;

    if (isNotValidArguments) {
      throw new Error("fetchAccounts: wrong arguments");
    }

    try {
      const account = await api.get("/profile/subusers");

      if (!account?.parent) {
        throw new Error("incorrect response body");
      }

      commit("SET_ACCOUNTS", account?.parent);
      commit("SET_SUB_IDENTIFIERS", account?.subusers);
    } catch (e) {
      logErrorToSentry("loadAccountList", "response.error", e);

      throw new Error(e);
    }
  },

  ...SUB_ACTIONS,
};
